export const alert = ({isOpen,component}) => {
    return{
        type: "OPEN-OR-CLOSE-ALERT",
        isOpen : isOpen,
        component : component
    }
}